// Round only for display, using decimal digits rather than binary floats.
export function decimal(value: string | null | undefined, places = 2): string {
  if (typeof value !== 'string' || value.length > 4096 || !/^-?\d+(\.\d+)?$/.test(value))
    return '—';
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = value.replace(/^-/, '').split('.');
  let scaled = BigInt(whole + fraction.padEnd(places, '0').slice(0, places));
  if (Number(fraction[places] || '0') >= 5) scaled += 1n;
  const digits = scaled.toString().padStart(places + 1, '0');
  const integer = places ? digits.slice(0, -places) : digits;
  return `${negative && scaled !== 0n ? '−' : ''}${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${places ? '.' + digits.slice(-places) : ''}`;
}
export function money(
  value: string | null | undefined,
  currency: string | null | undefined,
  signed = false,
): string {
  const amount = decimal(value);
  if (amount === '—') return amount;
  const prefix =
    currency === 'USD' ? '$' : currency === 'CAD' ? 'CA$' : `${currency || 'Currency unknown'} `;
  const sign = amount.startsWith('−') ? '−' : signed && !/^0+(\.0+)?$/.test(amount) ? '+' : '';
  return `${sign}${prefix}${amount.replace(/^−/, '')}`;
}
export const isZero = (value: string | null | undefined) =>
  typeof value === 'string' && /^-?0+(\.0+)?$/.test(value);
/** CSS class for a signed decimal string: positive, negative, or muted when unknown/zero. */
export function tone(value: string | null | undefined): string {
  if (typeof value !== 'string' || !/^-?\d+(\.\d+)?$/.test(value) || isZero(value))
    return 'cost-basis-muted';
  return value.startsWith('-') ? 'cost-basis-negative' : 'cost-basis-positive';
}
